import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  TextField,
  Grid,
  Container,
  Autocomplete,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import ShepButton from "@/components/GenericComponents/ShepButton";
import { useDispatch } from "react-redux";
import { handleAddCatalog } from "@/features/connections/manageCatalogDataSlice";
import { defaultCode } from "@/features/connections/integrationSlice";
import axios from "@/features/axiosHelper";
//SHEP-940 Duplicate of AddAllowanceChargePopup with a couple tweaks
//required since the original required being used within a grid
//removed redux states and grid context

const EmailAddAllowanceChargePopup = ({
  open,
  onClose,
  onSuccess,
  initialRefId = "",
  initialIndicator = "",
  initialDescription = "",
  connectionId,
  connectionName = "",
  artifactType = 2009,
}) => {
  const dispatch = useDispatch();
  const [dataValues, setDataValues] = useState({});
  const [selectedIndicator, setIndicator] = useState("");

  useEffect(() => {
    if (open) {
      setDataValues({
        ACCode: initialRefId,
        ACCodeDescription: initialDescription,
      });
      setIndicator(initialIndicator || "");
    }
  }, [open, initialRefId, initialIndicator, initialDescription]);

  const validateForm = () => {
    if (!selectedIndicator) {
      return {
        isValid: false,
        message: "Please select a type indicator",
      };
    }
    if (dataValues.ACCode === defaultCode) {
      return {
        isValid: false,
        message: `AC Code cannot be saved as ${defaultCode}`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
    setDataValues({});
    setIndicator("");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDataValues((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchCatalog = async () => {
    try {
      const response = await axios.get("/email/catalogs", {
        params: {
          connectionId: connectionId,
          dataType: artifactType,
          maxCount: 1,
          search: dataValues.ACCode,
          parentCatalogId: null,
        },
      });
      const results = response.data.Records;
      return results.length > 0 ? response.data.Records[0] : null;
    } catch (error) {
      console.error("Error fetching new catalog: ", error);
      return null;
    }
  };

  const options = ["Allowance", "Charge"];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={"xl"}
      fullWidth={true}
      PaperProps={{ style: { borderRadius: 15 } }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          fontSize: "24px",
          borderRadius: "15px 15px 0 0",
          padding: "16px 24px",
        }}
      >
        <div style={{ fontWeight: "var(--font-semi-bold)" }}>
          {"Add Catalog - Allowance/Charge for " +
            (connectionName || "Connection")}
        </div>
        <IconButton
          onClick={handleClose}
          className="closeIconButton"
          style={{ color: "var(--default-light)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="dialogContent"
        style={{
          backgroundColor: "var(--disabled)",
          padding: "35px",
          minWidth: 400,
        }}
      >
        <Container>
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            style={{ marginBottom: "20px", marginTop: "20px" }}
            sx={{
              px: 20,
            }}
          >
            <Grid item xs={4}>
              <Typography>
                Type Indicator{" "}
                <Typography
                  component="span"
                  sx={{ color: "red", fontSize: "1.2rem", fontWeight: "bold" }}
                >
                  *
                </Typography>
              </Typography>
              <Autocomplete
                options={options}
                value={selectedIndicator}
                onChange={(e, newValue) => {
                  setIndicator(newValue || null);
                }}
                renderInput={(params) => (
                  <TextField
                    sx={{ marginTop: 1, marginBottom: 2, maxWidth: 250 }}
                    {...params}
                    autoComplete="off"
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography>AC Code </Typography>
              <TextField
                variant="outlined"
                name="ACCode"
                value={dataValues?.ACCode || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography>Handling Code</Typography>
              <Typography>
                <TextField
                  variant="outlined"
                  name="HandlingCode"
                  value={dataValues?.HandlingCode || ""}
                  onChange={handleChange}
                  sx={{
                    width: 250,
                    marginTop: 1,
                    marginBottom: 2,
                  }}
                />
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>Description</Typography>
              <Typography>
                <TextField
                  variant="outlined"
                  name="ACCodeDescription"
                  value={dataValues?.ACCodeDescription || ""}
                  onChange={handleChange}
                  sx={{
                    width: 250,
                    marginTop: 1,
                    marginBottom: 2,
                  }}
                />
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <ShepButton variant="secondary" onClick={handleClose}>
          Cancel
        </ShepButton>
        <ShepButton
          onClick={async () => {
            const onSuccessfulSave = async () => {
              handleClose();
              if (onSuccess) {
                const newData = await fetchCatalog();
                onSuccess(newData);
              }
            };
            await handleAddCatalog(
              validateForm,
              onSuccessfulSave,
              dispatch,
              connectionId,
              artifactType,
              JSON.stringify({
                ...dataValues,
                connectionName,
                Indicator: selectedIndicator,
              }),
            );
          }}
        >
          Add
        </ShepButton>
      </DialogActions>
    </Dialog>
  );
};

export default EmailAddAllowanceChargePopup;
